import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { styled, alpha }, "@mui/material/AppBar": AppBar, "@mui/material/Box": Box, "@mui/material/Toolbar": Toolbar, "@mui/material/IconButton": IconButton, "@mui/material/Typography": Typography, "@mui/material/InputBase": InputBase, "@mui/icons-material/Menu": MenuIcon, "@mui/icons-material/Search": SearchIcon } } });
export default ClientProvider;
